import { useState, useEffect } from 'react'

export default function useOnScreen({ target, enabled = true }) {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    if (!enabled) return

    const callback = ([entry]) => {
      setIntersecting(entry.isIntersecting)
    }

    const observer = new IntersectionObserver(callback)
    const el = target?.current

    if (!el) {
      return
    }

    observer.observe(el)

    // Remove the observer as soon as the component is unmounted
    return () => {
      observer.unobserve(el)
    }
  }, [target, enabled])

  return isIntersecting
}
